import { BaseGroupModal } from './base';
import {
  editGroup,
  setEditGroupValue
} from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisShowToastr } from '../../../../redux/slices/utils/ui/toastr';
import { useTranslate } from '@tolgee/react';

export const EditGroupModal: React.FC<any> = ({ show, onHide, onSave }) => {
  const { t } = useTranslate();
  const {
    data: { edit_group_data, users }
  } = useSelector((state: any) => state.lomavisPostApproval);

  const dispatch = useDispatch();
  const setValue = ({ key, value }) => {
    dispatch(setEditGroupValue({ key, value }));
  };
  const onDataSave = () => {
    dispatch(editGroup() as any);
    lomavisShowToastr(
        t('lomavisPostApproval.createGroup.groupEdited'),
        'success'
    );
    onHide();
    onSave();
  };
  return (
    <BaseGroupModal
      show={show}
      onHide={onHide}
      setValue={setValue}
      groupData={edit_group_data}
      onSave={onDataSave}
      users={users}
    />
  );
};
